import request from '@/request/request'

// 查询报警配置列表
export function listWarnConfig(query) {
    return request({
        url: '/api/equipment-server/warnConfig/list',
        method: 'get',
        params: query
    })
}

// 查询报警配置详细
export function getWarnConfigById(id) {
    return request({
        url: '/api/equipment-server/warnConfig/' + id,
        method: 'get'
    })
}

// 新增报警配置
export function addWarnConfig(data) {
    return request({
        url: '/api/equipment-server/warnConfig',
        method: 'post',
        data: data
    })
}

// 修改报警配置
export function updateWarnConfig(data) {
    return request({
        url: '/api/equipment-server/warnConfig/edit',
        method: 'post',
        data: data
    })
}

// 删除报警配置
export function delWarnConfig(id) {
    return request({
        url: '/api/equipment-server/warnConfig/delete/' + id,
        method: 'post'
    })
}

